export enum ApiServicesEnum {
    AFFILIATION_ACCOUNT = 'affiliation-cloud',
    CURRENCY_SERVICE = 'currency-service',
    POSTBACKS_SERVICE = 'postbacks-service',
    REDIRECTOR_SERVICE = 'redirector-service',
    RAKECOLLECT_SERVICE = 'rakecollect-service',
}
